import { useState } from 'react';

import { useAppDispatch } from 'segments/hooks';

import { changeGroupsActiveModal } from 'features/groups';

import { Modals, TablePage } from 'widgets/groups';

const Groups = () => {
  const dispatch = useAppDispatch();
  const [selectedGroupeId, setSelectedGroupeId] = useState<number>();

  const handleCreateClick = () => {
    dispatch(changeGroupsActiveModal('create-groupe-modal'));
  };

  const handleEditClick = (id: number) => {
    setSelectedGroupeId(id);
    dispatch(changeGroupsActiveModal('edit-groupe-modal'));
  };

  return (
    <div>
      <TablePage
        handleCreateClick={handleCreateClick}
        handleEditClick={handleEditClick}
      />
      <Modals
        selectedGroupeId={selectedGroupeId}
      />
    </div>
  );
};

export default Groups;
